/**
 * 获取专业树的模拟数据
 */
export function getInitDepartmentTree() {
    return [{
            name: "一级 1",
            children: [{
                name: "二级 1-1",
                children: [{
                    name: "三级 1-1-1",
                    children: [],
                }, ],
            }, ],
        },
        {
            name: "一级 2",
            children: [{
                    name: "二级 2-1",
                    children: [{
                        name: "三级 2-1-1",
                    }, ],
                },
                {
                    name: "二级 2-2",
                    children: [{
                        name: "三级 2-2-1",
                    }, ],
                },
            ],
        },
        {
            name: "一级 3",
            children: [{
                    name: "二级 3-1",
                    children: [{
                        name: "三级 3-1-1",
                    }, ],
                },
                {
                    name: "二级 3-2",
                    children: [{
                        name: "三级 3-2-1",
                    }, ],
                },
            ],
        },
    ]
}

/**
 * 获取专业下员工表格的表头
 */
export function getTableMenu() {
    return [
        { name: "姓名", key: "name", width: "", isTip: true },
        { name: "职业技能等级", key: "leverl", width: "", isTip: false },
        { name: "身份证", key: "identityCard", width: "", isTip: false },
        { name: "账号", key: "account", width: "", isTip: false },
    ]
}

/**
 * 初始化该专业下员工表格数据
 */
export function initTableData() {
    return [
        { id: "", name: "张三", account: "2000521", identityCard: "325698545822224586", isLeader: true },
        { id: "", name: "李四", account: "2000522", identityCard: "325698545822224586", isLeader: false },
    ]
}

/**
 * 获取弹出框的界面布局数据
 * @param {*} active 对应操作
 */
export function getDialogDataForPage(active) {
    let data = []
    switch (active) {
        case "edit_profession":
            // 编辑专业
            data = [
                { title: "专业名称", type: "input", value: "", key: "name", isNotNull: true },
                { title: "专业别名", type: "tips_text", value: [], key: "alias", isNotNull: false },
            ]
            break;
        case "add_profession_childer":
            // 添加子专业
            data = [
                { title: "专业名称", type: "input", value: "", key: "name", isNotNull: true },
                { title: "专业别名", type: "tips_text", value: [], key: "alias", isNotNull: false },
            ]

            break;
        case "add_user":
            // 添加学员
            data = [
                { title: "", type: "add-user", value: [], userAllList: [], key: "addUser", isNotNull: false },
            ]
            break

        default:
            break;
    }
    return data
}